module.exports = __webpack_public_path__ + "img/paymentDummy.b8b8bfa.png";